import React from "react";
import { StaffLoginData } from "../Api/Staff";
import { StoreData } from "../Objects/StoreInterface";
import { StudioData } from "../Objects/StudioInterface";

interface StoreObjectInterface {
    storeData?: StoreData
    studioList?: StudioData[]
}

const initialState: StoreObjectInterface = {
    storeData: undefined
}

type Action =
    | { type: 'setStoreData', payload: StoreData }
    | { type: 'setStudioList', payload: StudioData[] }
    | { type: 'unsetData' }


export const StoreObjectStore = React.createContext({} as {
    storeObjectState: StoreObjectInterface,
    storeObjectDispatch: React.Dispatch<Action>
})

const reducer = (dataState: StoreObjectInterface, action: Action): StoreObjectInterface => {
    switch (action.type) {
        case 'setStoreData':
            return {
                ...dataState,
                storeData: action.payload
            }
        case 'setStudioList':
            return {
                ...dataState,
                studioList: action.payload
            }
        case 'unsetData':
            return initialState
        default:
            throw new Error()
    }
}

export const StoreObjectProvider = (props: React.PropsWithChildren<{}>) => {
    const [storeObjectState, storeObjectDispatch] = React.useReducer<React.Reducer<StoreObjectInterface, Action>>(reducer, initialState)
    return (
        <StoreObjectStore.Provider value={{ storeObjectState, storeObjectDispatch }} {...props} />
    )
}